import TestSuites from './TestSuites';

export default TestSuites;
